module.exports = __webpack_public_path__ + "static/media/Ethax_Router_Comprehensive_Smart_Contract_Audit_SOKEN.06256d99.pdf";